// activityNewUser3
export default {
  routerTitle: '新客户三重奖赏',
  giftPackage: '礼包',
  shareTitle: '新客户三重奖赏(新年福利）',
  shareDesc: '最高享价值3800HKD大礼包，认购投资组合享高达500HKD！',

  cardOneTitle: '注册就送88HKD礼包',
  cardOneText: '30天美股LV1行情券',

  cardTwoTitle: '开户就送2256HKD礼包',
  cardTwoText1: '180天港股LV2',
  cardTwoText2: '180天美股LV1',

  cardThreeTitle: '入金2W最高赠送',
  cardThreeTabelTitle: '首笔入金≥2万HKD',
  cardThreeTabelRow1Left1: '30天内无出金记录',
  cardThreeTabelRow1Left2: '且30天内交易一次',
  cardThreeTabelRow1Right1: '满足条件就送',
  cardThreeTabelRow1Right2: '300HKD',
  cardThreeTabelRow1Right3: '现金券',
  cardThreeTabelRow2Left1: '开通投资组合账户',
  cardThreeTabelRow2Right1: '送',
  cardThreeTabelRow2Right2: '福特(NYSE：F)-2股',

  cardFourTitle: '入金30W最高赠送',
  cardFourTabelTitle: '首笔入金≥30万HKD',
  cardFourTabelRow1Left1: '30天内无出金记录',
  cardFourTabelRow1Left2: '且30天内交易一次',
  cardFourTabelRow1Right1: '满足条件就送',
  cardFourTabelRow1Right2: '1300HKD',
  cardFourTabelRow1Right3: '现金券',
  cardFourTabelRow2Left1: '开通投资组合账户',
  cardFourTabelRow2Right1: '送',
  cardFourTabelRow2Right2: '福特(NYSE：F)-2股',

  cardFiveTitle: '首次认购盈宝投资组合专享',
  cardFiveTabelTitle: '首次认购≥1000USD',
  cardFiveTabelRow1Left1: '连续持有满30天',
  cardFiveTabelRow1Left2: '且无转出资金',
  cardFiveTabelRow1Right1: '满足条件就送',
  cardFiveTabelRow1Right2: '300HKD',
  cardFiveTabelRow1Right3: '现金券',

  pageTips: '注：首笔入金2万奖励和首笔入金30万奖励只能参与一个'
}
